var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgScales = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 36,
  height: 36,
  fill: "none"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#FFB64C",
  d: "M7.455 7.453h-2.27L0 20.11l1.125 1.055 1.073-1.055 4.13-9.914 4.13 9.914 1.106 1.055 1.092-1.055z"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  fill: "#FF9100",
  d: "M30.799 7.453h-2.27L23.345 20.11l1.125 1.055 1.072-1.055 4.13-9.914 4.132 9.914 1.105 1.055L36 20.11z"
})), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
  fill: "#FFD396",
  d: "M18 0h-1.055v5.344h2.11V0z"
})), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
  fill: "#FFB64C",
  d: "M18 0h1.055v5.344H18z"
})), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
  fill: "#FFD396",
  d: "M2.11 6.398h13.78v2.11H2.11z"
})), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
  fill: "#FFB64C",
  d: "M20.11 6.398h13.78v2.11H20.11z"
})), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
  fill: "#FFD396",
  d: "M18 9.563h-1.055v19.054h2.11V9.563z"
})), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
  fill: "#FFB64C",
  d: "M18 9.563h1.055v19.054H18z"
})), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
  fill: "#FFD396",
  d: "M0 20.11a5.273 5.273 0 0 0 5.273 5.273h2.11a5.273 5.273 0 0 0 5.273-5.274z"
})), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
  fill: "#FFB64C",
  d: "M23.344 20.11a5.273 5.273 0 0 0 5.273 5.273h2.11A5.273 5.273 0 0 0 36 20.109zM18 10.617a3.164 3.164 0 1 0 0-6.328 3.164 3.164 0 0 0 0 6.328"
})), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
  fill: "#FF9100",
  d: "M21.164 7.453A3.17 3.17 0 0 0 18 4.29v6.328a3.17 3.17 0 0 0 3.164-3.164"
})), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
  fill: "#FFB64C",
  d: "M18 27.563a5.28 5.28 0 0 0-5.273 5.273h10.546A5.28 5.28 0 0 0 18 27.563"
})), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
  fill: "#FF9100",
  d: "M18 27.563v5.273h5.273A5.28 5.28 0 0 0 18 27.563"
})), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
  fill: "#FFD396",
  d: "M24.328 31.781H11.672a3.164 3.164 0 0 0-3.164 3.164V36h18.984v-1.055a3.164 3.164 0 0 0-3.164-3.164"
})), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
  fill: "#FFB64C",
  d: "M27.492 34.945a3.164 3.164 0 0 0-3.164-3.164H18V36h9.492z"
})));
export default SvgScales;